import { render, staticRenderFns } from "./iconSmile.vue?vue&type=template&id=1c213aac"
import script from "./iconSmile.vue?vue&type=script&lang=js"
export * from "./iconSmile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports